<div mat-dialog-title>{{ $interest().emoji }} {{ $interest().name }}</div>

<div mat-dialog-content>
  <div class="my-stats">
    <div class="title-medium">My stats</div>
    <div>TBD</div>
  </div>
  <div class="pueblo-stats">
    <div class="title-medium">Pueblo stats</div>
    <div class="stats-row">
      <div>
        {{ $interest().users.length }}
        {{ $interest().users.length === 1 ? "user" : "users" }}
      </div>
      <div>
        {{ $interest().hangs.length }}
        {{ $interest().hangs.length === 1 ? "hang" : "hangs" }}
      </div>
    </div>
  </div>
</div>
